import { render, staticRenderFns } from "./oncallInfoTable.vue?vue&type=template&id=0da94f1c&"
import script from "./oncallInfoTable.vue?vue&type=script&lang=ts&"
export * from "./oncallInfoTable.vue?vue&type=script&lang=ts&"
import style0 from "./oncallInfoTable.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports